import { render, staticRenderFns } from "./SplashPanel.vue?vue&type=template&id=b885e3c8&scoped=true&"
import script from "./SplashPanel.vue?vue&type=script&lang=ts&"
export * from "./SplashPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SplashPanel.vue?vue&type=style&index=0&id=b885e3c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b885e3c8",
  null
  
)

export default component.exports